import {useEffect,useState} from 'react';
import SafeIcon from '../common/SafeIcon';
import { BOOKING_URL } from '../data/booking';
import './nav-responsive.css';

const links=[
  ['Home','/#home'],['Rooms','/#rooms'],['Experience','/#experience'],['Gallery','/#gallery'],['Location','/#location'],['Contact','/#contact']
];

function SiteHeader({BrandMark,solid=false}) {
  const [scrolled,setScrolled]=useState(false);
  const [menuOpen,setMenuOpen]=useState(false);
  const isSolid=scrolled || solid;

  useEffect(()=> {
    const handleScroll=()=> setScrolled(window.scrollY > 35);
    handleScroll();
    window.addEventListener('scroll',handleScroll,{passive: true});
    return ()=> window.removeEventListener('scroll',handleScroll);
  },[]);

  return (
    <header className={`site-header ${isSolid ? 'site-header--solid' : ''}`}>
      <BrandMark light={!isSolid} />
      <button type="button" className="menu-toggle" onClick={()=> setMenuOpen((open)=> !open)} aria-label={menuOpen ? 'Close menu' : 'Open menu'} aria-expanded={menuOpen}>
        <SafeIcon name={menuOpen ? 'X' : 'Menu'} />
      </button>
      <nav className={menuOpen ? 'site-nav site-nav--open' : 'site-nav'} aria-label="Main navigation">
        {links.map(([label,href])=> <a key={label} href={href} onClick={(event)=> {
          setMenuOpen(false);
          if (window.location.pathname === '/' && window.location.hash === href.slice(1)) {
            event.preventDefault();
            document.getElementById(href.slice(2))?.scrollIntoView({behavior: 'smooth'});
          }
        }}>{label}</a>)}
        <a className="site-nav__book" href={BOOKING_URL} target="_blank" rel="noreferrer">Book a stay <SafeIcon name="ArrowUpRight" /></a>
      </nav>
    </header>
  );
}

export default SiteHeader;